export default {
  title: 'Jak działają prowizje za przetwarzanie',
  how_it_works:
    'Stripe pobiera swoją prowizję od Twojej platformy przy każdej płatności online przyjętej przez Twoje restauracje. Ustawiona przez Ciebie prowizja za przetwarzanie to kwota, którą restauracja płaci za tę płatność. Jeśli jest wyższa niż prowizja Stripe, różnicę zatrzymujesz jako swoją marżę. Jeśli jest niższa lub nie ustawisz żadnej, różnicę pokrywasz sam.',
  stripe_rates_link: 'Zobacz standardowe stawki Stripe',
  example: {
    intro:
      'Przykład: zamówienie na {{total}} opłacone kartą. Stripe pobiera od Twojej platformy {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Twoja stawka {{rate}}: restauracja płaci {{fee}}, Ty zatrzymujesz {{difference}}.',
    below: 'Twoja stawka {{rate}}: restauracja płaci {{fee}}, Ty pokrywasz różnicę {{difference}}.',
    none: 'Brak stawki (0% marży): restauracja nie płaci nic, Ty pokrywasz całą prowizję {{stripe_fee}}.',
    disclaimer:
      'Prowizja Stripe podana tutaj to jego standardowa stawka za karty w EOG, wyłącznie poglądowo. Rzeczywista prowizja zależy od karty, jej kraju i Twojego cennika Stripe.',
  },
};
